import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiMessage } from '../../models';
import { GlobalService } from '../../../../_core/state/global';

@Component({
  selector: 'app-ai-copy-suggestions-renderer',
  templateUrl: './copy-suggestions-renderer.component.html',
  styleUrls: ['./copy-suggestions-renderer.component.scss']
})
export class CopySuggestionsRendererComponent {
	copyToClipboardId: string | null = null;
	copyToClipboardStatusTimeout: any = null;

  @Input() message!: AiMessage; // expects content: { groups: { title?: string; items: { id: string; text: string; added?: boolean }[] }[] }
  @Output() action = new EventEmitter<{ type: string; itemId?: string; itemIds?: string[]; item?: any; items?: any[]; groupTitle?: string }>();
  @Input() addedIds: string[] = [];

  constructor(private readonly globalService: GlobalService) {
  }

  isAdded(item: any): boolean {
    const ids = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
    return ids.has(item?.id);
  }

  isAllAdded(items: any): boolean {
    const ids = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
    return items.every((item: any) => ids.has(item.id));
  }

  add(item: any, groupTitle?: string) {
    this.action.emit({ type: 'add', itemId: item.id, item, groupTitle });
	  this.addedIds.push(item.id);
  }
	addAll(group: any) {
		const alreadyAdded = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
		const items = (group.items || []).filter((i: any) => !alreadyAdded.has(i.id)) || [];
		const itemIds = items.map((i: any) => i.id);

		this.action.emit({type: 'add-all', groupTitle: group.title, itemIds, items} as any);
		this.addedIds.push(...itemIds);
	}

	async copyToClipboard(item: any, groupTitle?: string) {
		if (item?.text) {
			this.globalService.copyToClipboard(item.text);

			if (this.copyToClipboardStatusTimeout) {
				clearTimeout(this.copyToClipboardStatusTimeout);
			}
			this.copyToClipboardId = item.id;
			this.copyToClipboardStatusTimeout = setTimeout(() => {
				this.copyToClipboardId = null;
			}, 2000);
		}
	}
}
